import { httpClient } from '../util/http-client'

export const fetcher = async (url: string) => {
  const { data } = await httpClient(url)

  return data.list
}
